var map = {
	"./template.bet575": 2025,
	"./template.bet575.tsx": 2025,
	"./template.bet777": 2026,
	"./template.bet777.tsx": 2026,
	"./template.betbetbet": 1991,
	"./template.betbetbet.tsx": 1991,
	"./template.betblast": 2027,
	"./template.betblast.tsx": 2027,
	"./template.betgalaxy": 1158,
	"./template.betgalaxy.tsx": 1158,
	"./template.betprofessor": 2028,
	"./template.betprofessor.tsx": 2028,
	"./template.betroyale": 2029,
	"./template.betroyale.tsx": 2029,
	"./template.betstride": 2030,
	"./template.betstride.tsx": 2030,
	"./template.buffalobet": 2031,
	"./template.buffalobet.tsx": 2031,
	"./template.chromabet": 2032,
	"./template.chromabet.tsx": 2032,
	"./template.default": 662,
	"./template.default.tsx": 662,
	"./template.fiestabet": 1992,
	"./template.fiestabet.tsx": 1992,
	"./template.forsport": 1159,
	"./template.forsport.tsx": 1159,
	"./template.gigabet": 2033,
	"./template.gigabet.tsx": 2033,
	"./template.goldenbet888": 1980,
	"./template.goldenbet888.tsx": 1980,
	"./template.goldenrush": 2034,
	"./template.goldenrush.tsx": 2034,
	"./template.hyperbet": 2035,
	"./template.hyperbet.tsx": 2035,
	"./template.juicybet": 2036,
	"./template.juicybet.tsx": 2036,
	"./template.junglebet": 2037,
	"./template.junglebet.tsx": 2037,
	"./template.magnumbet": 2038,
	"./template.magnumbet.tsx": 2038,
	"./template.oldgill": 1993,
	"./template.oldgill.tsx": 1993,
	"./template.puntcity": 1994,
	"./template.puntcity.tsx": 1994,
	"./template.puntgenie": 2039,
	"./template.puntgenie.tsx": 2039,
	"./template.pyramidbet": 1981,
	"./template.pyramidbet.tsx": 1981,
	"./template.questbet": 1995,
	"./template.questbet.tsx": 1995,
	"./template.slambet": 1996,
	"./template.slambet.tsx": 1996,
	"./template.sterlingparker": 1160,
	"./template.sterlingparker.tsx": 1160,
	"./template.sugarcastle": 2040,
	"./template.sugarcastle.tsx": 2040,
	"./template.templebet": 2041,
	"./template.templebet.tsx": 2041,
	"./template.titanbet": 2042,
	"./template.titanbet.tsx": 2042,
	"./template.ts": 381,
	"./template.vikingbet": 1997,
	"./template.vikingbet.tsx": 1997,
	"./template.volcanobet": 1978,
	"./template.volcanobet.tsx": 1978,
	"./template.wellbet": 2043,
	"./template.wellbet.tsx": 2043
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2430;